import React, { useEffect, useState } from 'react';
import {
  InputController,
  AutoCompleteController,
} from '../../../components';
import { Button } from '@mui/material';
import MultiSelect from '../../../components/formControllers/multiSelect';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  DropDownType,
  ListType,
} from '../../../pages/advanta-mvp-charts/constants';
import { useUpdateDropdownHierarchyQuery } from '../../../services/mVPGraphQlService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

export const UserEditForm = ({
  control,
  register,
  errors,
  onSubmit,
  handleClose,
  handleSubmit,
  watch,
  commonFilters,
  isDirty,
}) => {
  const [openConfirm, setOpenConfirm] =
    React.useState(false);
  const [formData, setFormData] = React.useState(null);
  const handleFormSubmit = (data) => {
    setFormData(data);
    setOpenConfirm(true);
  };
  const handleConfirmSave = () => {
    onSubmit(formData);
    setOpenConfirm(false);
  };

  const [rmListffc, setRegionManagerListFfc] = useState<
    DropDownType[]
  >([]);
  const [tpmListffc, setTpmListFfc] = useState<
    DropDownType[]
  >([]);
  const [plListffc, setPlListFfc] = useState<
    DropDownType[]
  >([]);
  const [scmListffc, setScmListFfc] = useState<
    DropDownType[]
  >([]);

  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const isThailand = useSelector(
    (state: RootState) => state.country.countryName
  ) === 'Thailand';
  const { data } = useUpdateDropdownHierarchyQuery({
    commonFilters,
    fullHierarchy: true,
    wsId: wsId,
  });

  function getRegionalManagers(
    hierarchy: any[],
    type: string,
    parentId: number | null = null
  ): any[] {
    const regionalManagers: {
      type: string;
      name: string;
      id: number;
      parentId: number;
    }[] = [];

    hierarchy.forEach((item) => {
      if (item.data?.type === type) {
        regionalManagers.push({
          ...item.data,
          parentId,
        });
      }

      if (item.hierarchy && Array.isArray(item.hierarchy)) {
        regionalManagers.push(
          ...getRegionalManagers(
            item.hierarchy,
            type,
            item.data?.id || null
          )
        );
      }
    });

    return regionalManagers;
  }

  const getFormattedList = (
    list: Array<ListType>,
    parentId?: string | null
  ): DropDownType[] => {
    if (parentId) {
      const formattedList = list
        .filter((item) => item?.parentId === parentId)
        .map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      return formattedList;
    } else {
      const formattedList = list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      return formattedList;
    }
  };

  useEffect(() => {
    if (!data?.data?.UpdateDropdownHierarchy) return;

    const regionalManagersFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'REGION_MANAGER'
    );

    const tpmFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'TPM'
    );

    const scmFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'SCM_LEAD'
    );

    const plFFC = getRegionalManagers(
      data.data.UpdateDropdownHierarchy.empHierarchyFfc
        ?.hierarchy || [],
      'PRODUCTION_LEAD'
    );

    const formattedListoRmffc = regionalManagersFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoTpmffc = tpmFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoScmffc = scmFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    const formattedListoPlffc = plFFC
      .map((item) => ({
        id: item.id,
        name: item.name,
        parentId: item.parentId,
      }))
      .filter((item) => item.name)
      .sort((a, b) => a.name.localeCompare(b.name));

    setRegionManagerListFfc(
      getFormattedList(formattedListoRmffc)
    );
    setTpmListFfc(getFormattedList(formattedListoTpmffc));
    setScmListFfc(getFormattedList(formattedListoScmffc));
    setPlListFfc(getFormattedList(formattedListoPlffc));
  }, [data]);

  return (
    <>
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 px-6 py-6 pb-24 md:pb-28">
        <InputController
          label="Name"
          register={register('name')}
          error={errors?.name?.message}
          required
        />
        <InputController
          label="UGDN"
          register={register('ugdn')}
          error={errors?.ugdn?.message}
          required
        />
        <InputController
          label="Mobile number"
          register={register('mobileDetails')}
          error={errors?.mobileDetails?.message}
          required
          digitsOnly
          maxDigits={10}
        />
        {isThailand && (
          <InputController
            label="Email"
            register={register('emailId')}
            error={errors?.emailId?.message}
            required
          />
        )}

        {/* <AutoCompleteController
          control={control}
          name="country"
          label="country"
          options={[
            { value: 'IN', label: 'India' },
            { value: 'TH', label: 'Thailand' },
          ]}
          required
          error={errors?.country?.message}
          disableClearable
        /> */}

        <AutoCompleteController
          control={control}
          name="userType"
          label="Role"
          options={[
            {
              value: 'SCM_LEAD',
              label: 'SCM LEAD',
            },
            {
              value: 'PRODUCTION_LEAD',
              label: 'PRODUCTION LEAD ',
            },
            {
              value: 'REGION_MANAGER',
              label: 'REGION_MANAGER',
            },
            {
              value: 'TPM',
              label: isThailand ? 'APM' : 'TPM',
            },
            {
              value: 'FA',
              label: isThailand ? 'PE' : 'FA',
            },
          ]}
          required
          error={errors?.userType?.message}
          disableClearable
        />

        <AutoCompleteController
          control={control}
          name="userFunction"
          label="Function"
          options={[
            {
              value: 'EMP_FIELD_CROP',
              label: 'Field crop',
            },
            {
              value: 'EMP_VEGETABLE_CROP',
              label: 'Vegetable crop',
            },
          ]}
          required
          error={errors?.userFunction?.message}
          disableClearable
        />

        <AutoCompleteController
          control={control}
          name="userSubFunction"
          label="Sub Function"
          options={[
            {
              value: 'SF_COMMERCIAL_SEED_PRODUCTION',
              label: 'COMMERCIAL SEED PRODUCTION',
            },
            {
              value: 'SF_FC_CROP_QUALITY',
              label: 'CROP QUALITY',
            },
            {
              value: 'SF_PARENT_SEED_PRODUCTION',
              label: 'PARENT SEED PRODUCTION',
            },
            {
              value: 'SF_QUALITY_MANAGEMENT',
              label: 'QUALITY MANAGEMENT',
            },
          ]}
          required
          error={errors?.userSubFunction?.message}
          disableClearable
        />
        {watch('userType') == 'FA' && (
          <MultiSelect
            control={control}
            name="fields"
            label="Fields"
            options={[
              { value: 'def', label: 'def' },
              { value: 'def2', label: 'def2' },
            ]}
            disabled
          />
        )}
        {watch('userType') != 'SCM_LEAD' && (
          <AutoCompleteController
            control={control}
            name={
              watch('userType') == 'FA'
                ? 'tpmId'
                : watch('userType') == 'TPM'
                ? 'regionManagerId'
                : watch('userType') == 'REGION_MANAGER'
                ? 'plId'
                : watch('userType') == 'PRODUCTION_LEAD'
                ? 'scmId'
                : 'scmId'
            }
            label={
              watch('userType') == 'FA'
                ? isThailand ? 'APM' : 'TPM'
                : watch('userType') == 'TPM'
                ? 'REGION MANAGER'
                : watch('userType') == 'REGION_MANAGER'
                ? 'PRODUCTION LEAD'
                : watch('userType') == 'PRODUCTION_LEAD'
                ? 'SCM LEAD'
                : 'user'
            }
            placeholder="Select"
            options={
              watch('userType') == 'FA'
                ? tpmListffc
                : watch('userType') == 'TPM'
                ? rmListffc
                : watch('userType') == 'REGION_MANAGER'
                ? plListffc
                : watch('userType') == 'PRODUCTION_LEAD'
                ? scmListffc
                : []
            }
            disableClearable
          />
        )}
        <div className="col-span-full form-control mt-8 flex justify-end gap-4">
          <Button
            variant="outlined"
            onClick={handleClose}
            size="large"
            sx={{
              color: '#006970',
              borderColor: '#006970',
            }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            //type="submit"
            onClick={handleSubmit(handleFormSubmit)}
            size="large"
            disabled={!isDirty}
            sx={{
              backgroundColor: '#006970',
              '&:hover': { backgroundColor: '#004c52' },
            }}>
            Save
          </Button>
        </div>
      </form>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        maxWidth="sm"
        fullWidth>
        <DialogTitle className="flex justify-between items-center">
          Confirm changes
          <IconButton onClick={() => setOpenConfirm(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <p className="text-sm text-gray-600">
            You’re about to save the updated user details.
            Are you sure you want to save changes?
          </p>
        </DialogContent>

        <DialogActions className="px-6 py-4">
          <Button
            variant="outlined"
            onClick={() => setOpenConfirm(false)}
            sx={{
              color: '#006970',
              borderColor: '#006970',
            }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleConfirmSave}
            sx={{
              backgroundColor: '#006970',
              '&:hover': { backgroundColor: '#004c52' },
            }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
